import React, { useEffect, useState, ChangeEvent, FormEvent } from "react";
import { errorHandler } from "../utils/errorHandler";
import { forgotPassword } from "../api/forgotPassword";

interface ForgotPasswordFormData {
  email: string;
}

const ForgotPassword = () => {
  const [formData, setFormData] = useState<ForgotPasswordFormData>({
    email: "",
  });
  const [errorMsg, setErrorMsg] = useState("");

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    try {
      const data = await forgotPassword({
        email: formData.email,
        password: "",
      });
      setErrorMsg(data.message);
    } catch (error) {
      const errorMessage = errorHandler(error);
      setErrorMsg(errorMessage);
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="flex min-h-screen items-center justify-center bg-gray-100">
      <form
        onSubmit={handleSubmit}
        className="flex w-full max-w-[400px] flex-col items-center justify-center rounded-lg bg-white p-8 shadow-lg"
      >
        <h2 className="mb-4 text-3xl font-bold text-blue">Forgot Password</h2>
        <input
          type="text"
          name="email"
          value={formData.email}
          onChange={handleChange}
          placeholder="Email"
          className="mb-4 w-full rounded-md border border-gray-300 p-2 focus:outline-none focus:ring-1 focus:ring-blue"
        />
        <button
          type="submit"
          className="w-full rounded-lg bg-blue px-4 py-2 text-white transition-colors hover:bg-blue-dark"
        >
          Submit
        </button>
        {errorMsg && <p className="mt-2 text-red-500">{errorMsg}</p>}
      </form>
    </div>
  );
};

export default ForgotPassword;
